import React, { useEffect, useRef, useState } from "react";
import { Box, Checkbox, Divider, Grid, Paper, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import styles from ".././../../styles.module.css";
import { Icon } from "@iconify/react";
import { StyledTableCell } from "../../reusableComponent/StyledTable";
import defaultImg from "../../../images/transfrent_logo2.png";
import convertToIndianWords from "../../reusableComponent/convertToIndianWords";
import { makeStyles } from "@mui/styles";

const StyledTableCellPrint = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    borderTop: "1px solid #616161 !important",
    borderBottom: "1px solid #616161 !important",
    fontSize: 12,
  },
  [`&.${tableCellClasses.body}`]: {
    borderTop: "1px solid #616161",
    borderBottom: "1px solid #616161",
    fontSize: 10,
    padding: "2px 4px 2px 4px !important",
  },
}));
const StyledTableRow = styled(TableRow)(() => ({
  // '&:nth-of-type(even)': {
  //     backgroundColor: 'whitesmoke',
  // },
  "&:hover": {
    backgroundColor: "whitesmoke",
  },

  // hide last border
  // '&:last-child td, &:last-child th': {
  //     border: 0,
  // },
}));
const useStyles = makeStyles((theme) => ({
  textPrint: {
    fontSize: "10px",
  },
  specialTypography: {
    // Define special CSS styles for specific Typography components
    fontWeight: "normal",
    fontSize: "14px",
    color: "blue",
  },
}));

const SalesInvoiceMailFormat = ({
  pEntryPrint,
  invoicePrintTitleDetails,
  printSetupDetails,
  invoiceSettingList,
}) => {
  const classes = useStyles();

  const printData = pEntryPrint;
  const invoicePrintTitle =
    invoicePrintTitleDetails && invoicePrintTitleDetails[0];
  const printSetup = printSetupDetails && printSetupDetails[0];
  const invoiceSetting = invoiceSettingList && invoiceSettingList[0];

  const shippingAdd = JSON.parse(printData.shipAddress);
  const billingAdd = JSON.parse(printData.billAddress);
  const terms = JSON.parse(printData.invoice_terms);
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  const dateConversion = (date) => {
    var today = new Date(date);
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    const convDate = dd + "/" + mm + "/" + yyyy;
    return convDate;
  };

  const imageUrl = textToImage(printSetup.watermarkText);
  function textToImage(text) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = 900;
    canvas.height = 400;
    let x = 470;

    context.font = "35px Arial";
    context.fillStyle = "#ff3333";
    context.textAlign = "center";
    context.fillText(text, x, canvas.height);
    // context.fillText(text,canvas.width, canvas.height);

    return canvas.toDataURL();
  }

  const imageUrl1 = textToImage1(printSetup.watermarkImage);
  function textToImage1(text) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = 900;
    canvas.height = 400;
    let x = 470;

    context.font = "35px Arial";
    context.fillStyle = "#ff3333";
    context.textAlign = "center";
    context.fillText(text, x, canvas.height);
    // context.fillText(text,canvas.width, canvas.height);

    return canvas.toDataURL();
  }

  return (
    <>
      <Box style={{ margin: "0px 15px 0px 15px", padding: "0" }}>
        <Box>
          <Box>
            <Paper style={{ boxShadow: "none" }}>
              <Box
                style={{
                  margin: "0px 30px 0px 30px",
                  border: "1px solid #000000",
                }}
              >
                {printSetup.watermarkImgCheckbox === "true" && (
                  <span
                    style={{
                      content: '""',
                      backgroundImage:
                        printSetup.watermarkImgCheckbox === "true"
                          ? `url(${printSetup.watermarkImage})`
                          : "none",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      width: "90%",
                      // height: '700px',
                      // height: printSetup.topMargin == "100" ? 400 : printSetup.topMargin == "150" ? 210 : printSetup.topMargin == "190" ? 150  : 80,
                      height:
                        printSetup.topMargin == "100"
                          ? 900
                          : printSetup.topMargin == "150"
                          ? 800
                          : printSetup.topMargin == "190"
                          ? 750
                          : 700,
                      // height:'88vh',
                      position: "absolute", // Position absolutely
                      // transform: 'rotate(-40deg)',
                      opacity: 0.2, // Rotate only the background image by 30 degrees
                    }}
                  ></span>
                )}
                {printSetup.watermarkTextCheckbox === "true" && (
                  <>
                    <span
                      style={{
                        backgroundImage:
                          printSetup.watermarkTextCheckbox === "true"
                            ? `url(${imageUrl})`
                            : "none", // Convert text to an image
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        // backgroundSize: 'cover',
                        backgroundAttachment: "fixed",
                        width: "70%",
                        height: "700px",
                        position: "absolute",
                        transform: `rotate(${printSetup.watermarkTextRotate}deg)`,
                        opacity: 0.3,
                      }}
                    ></span>
                  </>
                )}

                <Grid container>
                  <Grid item xs={12} style={{ backgroundColor: "#c0c0c0" }}>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "bold",
                        paddingTop: "0.5px",
                        paddingBottom: "0px",
                      }}
                    >
                      TAX INVOICE
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{
                      borderTop: "1px solid #616161",
                      marginTop: "30px",
                    }}
                  >
                    <Grid container style={{ height: "120px" }}>
                      <Grid
                        item
                        xs={3}
                        style={{
                          padding: "4px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={userInfo.logo_image}
                          style={{
                            width: "160px",
                            height: "100px",
                            borderRadius: "4px",
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={9}
                        style={{
                          padding: "4px 4px 4px 8px",
                          borderLeft: "1px solid #616161",
                        }}
                      >
                        <Typography
                          style={{ fontSize: "24px", fontWeight: "bold" }}
                        >
                          {" "}
                          {userInfo.company}{" "}
                        </Typography>

                        <Typography
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "#000000",
                            backgroundColor: "#e6e6e6",
                          }}
                        >
                          {userInfo.companyDescription}
                        </Typography>
                        <Typography className="textPrintHeader">
                          {userInfo.companyAddress}, {userInfo.companyCity} -{" "}
                          {userInfo.companyPinCode} , {userInfo.state}
                        </Typography>
                        <Typography className="textPrintHeader">
                          <span
                            style={{ fontWeight: "bold", marginRight: "5px" }}
                          >
                            Mob No. :{" "}
                          </span>
                          {userInfo.mobileNumber}{" "}
                          <span
                            style={{ fontWeight: "bold", marginRight: "5px" }}
                          >
                            Email Id :{" "}
                          </span>{" "}
                          {userInfo.email}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{ borderTop: "1px solid #616161", height: "23px" }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={6}
                        style={{ display: "flex", padding: "1px 1px 1px 8px" }}
                      >
                        <Typography
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          GSTIN
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingLeft: "10px",
                          }}
                        >
                          :
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingLeft: "10px",
                          }}
                        >
                          {" "}
                          {userInfo.companyGstIN}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{
                          borderLeft: "1px solid #616161",
                          display: "flex",
                          padding: "1px 1px 1px 8px",
                        }}
                      >
                        <Typography
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          PAN NO
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingLeft: "10px",
                          }}
                        >
                          :
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            paddingLeft: "10px",
                          }}
                        >
                          {" "}
                          {userInfo.companyPanNo}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item xs={12} style={{ borderTop: '1px solid #616161',borderBottom: '1px solid #616161', height: '10px' }}> </Grid> */}
                </Grid>
                <Grid
                  container
                  style={{ height: "176px", borderTop: "1px solid #616161" }}
                >
                  <Grid
                    item
                    xs={4}
                    style={{ borderRight: "1px solid #616161" }}
                  >
                    <Box
                      style={{
                        padding: "3px 4px 4px 6px",
                        margin: "1px",
                        textAlign: "left",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <Typography
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                      >
                        BILL TO:
                      </Typography>
                      <Typography
                        style={{ fontSize: "12px", fontWeight: "bold" }}
                      >
                        {printData.CNS_Name}
                      </Typography>
                      <Typography className="textPrint">
                        {billingAdd.address}
                      </Typography>
                      <Typography className="textPrint">
                        {billingAdd.state}, {billingAdd.pinCode}
                      </Typography>
                      <Typography className="textPrint">
                        <strong style={{ fontWeight: "500" }}>GSTIN: </strong>{" "}
                        {billingAdd.gstn}
                      </Typography>
                      {/* {billingAdd.contact_person !== undefined && */}
                      <Typography className="textPrint">
                        <strong style={{ fontWeight: "500" }}>
                          {" "}
                          Contact Person:{" "}
                        </strong>{" "}
                        {billingAdd.contact_person}
                      </Typography>
                      {/* } */}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{ borderRight: "1px solid #616161" }}
                  >
                    <Box
                      style={{
                        padding: "3px 4px 4px 6px",
                        margin: "1px",
                        textAlign: "left",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <Typography
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                      >
                        SHIP TO:
                      </Typography>
                      {printData.sameAddressCondition == 1 ? (
                        <>
                          <Typography
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            {billingAdd.party}
                          </Typography>
                          <Typography className="textPrint">
                            {billingAdd.address}
                          </Typography>
                          <Typography className="textPrint">
                            {billingAdd.state}, {billingAdd.pinCode}
                          </Typography>
                          <Typography className="textPrint">
                            <strong style={{ fontWeight: "500" }}>
                              {" "}
                              GSTIN:
                            </strong>{" "}
                            {billingAdd.gstn}
                          </Typography>
                          <Typography className="textPrint">
                            <strong style={{ fontWeight: "500" }}>
                              {" "}
                              Contact Person:{" "}
                            </strong>
                            {billingAdd.contact_person}
                          </Typography>
                          <Typography
                            className="textPrint"
                            style={{ textDecoration: "underline" }}
                          >
                            <strong style={{ fontWeight: "500" }}>
                              {" "}
                              Date & Time Of Supply :
                            </strong>{" "}
                            {dateConversion(printData.invoiceDate)}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            {shippingAdd.party}
                          </Typography>
                          <Typography className="textPrint">
                            {shippingAdd.address}
                          </Typography>
                          <Typography className="textPrint">
                            {shippingAdd.state}, {shippingAdd.pinCode}
                          </Typography>
                          <Typography className="textPrint">
                            <strong style={{ fontWeight: "500" }}>
                              {" "}
                              Contact Person:{" "}
                            </strong>
                            {shippingAdd.contact_person}
                          </Typography>
                          <Typography className="textPrint">
                            <strong style={{ fontWeight: "500" }}>
                              {" "}
                              Contact No:
                            </strong>{" "}
                            {shippingAdd.contact_no}
                          </Typography>
                          <Typography
                            className="textPrint"
                            style={{ textDecoration: "underline" }}
                          >
                            <strong style={{ fontWeight: "500" }}>
                              {" "}
                              Date & Time Of Supply :
                            </strong>{" "}
                            {dateConversion(printData.invoiceDate)}
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={4} style={{}}>
                    <Box
                      style={{
                        padding: "2px 4px 4px 6px",
                        margin: "1px",
                        textAlign: "left",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <Grid container style={{}}>
                        <Grid item xs={4.5}>
                          <Box>
                            <Typography
                              style={{ fontWeight: "bold", fontSize: "13px" }}
                            >
                              Invoice No
                            </Typography>
                            <Typography
                              className="textPrint"
                              style={{ fontWeight: "bold" }}
                            >
                              Invoice Date
                            </Typography>

                            <Typography
                              className="textPrint"
                              style={{ fontWeight: "bold" }}
                            >
                              Challan No
                            </Typography>
                            <Typography
                              className="textPrint"
                              style={{ fontWeight: "bold" }}
                            >
                              Challan Date
                            </Typography>
                            <Typography
                              className="textPrint"
                              style={{ fontWeight: "bold" }}
                            >
                              PO No
                            </Typography>
                            <Typography
                              className="textPrint"
                              style={{ fontWeight: "bold" }}
                            >
                              PO Date
                            </Typography>
                            {invoiceSetting.showEWayBillNo === "true" && (
                              <Typography
                                className="textPrint"
                                style={{ fontWeight: "bold" }}
                              >
                                E-Way Bill No
                              </Typography>
                            )}
                            {invoiceSetting.showTransportMode === "true" && (
                              <Typography
                                className="textPrint"
                                style={{ fontWeight: "bold" }}
                              >
                                LR No
                              </Typography>
                            )}
                            {invoiceSetting.showVehicleNo === "true" && (
                              <Typography
                                className="textPrint"
                                style={{ fontWeight: "bold" }}
                              >
                                Vehicle No
                              </Typography>
                            )}
                            {invoiceSetting.showPaymentTerms === "true" && (
                              <Typography
                                className="textPrint"
                                style={{ fontWeight: "bold" }}
                              >
                                Payment Terms
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={0.5}>
                          <Box style={{ textAlign: "center" }}>
                            <Typography style={{ fontSize: "13px" }}>
                              :
                            </Typography>
                            <Typography className="textPrint">:</Typography>
                            <Typography className="textPrint">:</Typography>
                            <Typography className="textPrint">:</Typography>
                            <Typography className="textPrint">:</Typography>
                            <Typography className="textPrint">:</Typography>
                            {invoiceSetting.showEWayBillNo === "true" && (
                              <Typography className="textPrint">:</Typography>
                            )}
                            {invoiceSetting.showTransportMode === "true" && (
                              <Typography className="textPrint">:</Typography>
                            )}
                            {invoiceSetting.showVehicleNo === "true" && (
                              <Typography className="textPrint">:</Typography>
                            )}
                            {invoiceSetting.showPaymentTerms === "true" && (
                              <Typography className="textPrint">:</Typography>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={7} style={{}}>
                          <Box>
                            <Typography
                              style={{ fontSize: "13px", fontWeight: "bold" }}
                            >
                              {" "}
                              {printData.invoiceNo}
                            </Typography>
                            <Typography className="textPrint">
                              {" "}
                              {dateConversion(printData.invoiceDate)}
                            </Typography>
                            <Typography className="textPrint">
                              {" "}
                              {printData.challanNo == ""
                                ? "-"
                                : printData.challanNo}
                            </Typography>
                            <Typography className="textPrint">
                              {" "}
                              {printData.challanNo == ""
                                ? "-"
                                : dateConversion(printData.challanDate)}
                            </Typography>
                            <Typography className="textPrint">
                              {" "}
                              {printData.orderRefNo == ""
                                ? "-"
                                : printData.orderRefNo}
                            </Typography>
                            <Typography className="textPrint">
                              {" "}
                              {printData.orderRefNo == ""
                                ? "-"
                                : dateConversion(printData.orderRefDate)}
                            </Typography>
                            {invoiceSetting.showEWayBillNo === "true" && (
                              <Typography className="textPrint">
                                {" "}
                                {printData.eWayBillNo == ""
                                  ? "-"
                                  : printData.eWayBillNo}
                              </Typography>
                            )}
                            {invoiceSetting.showTransportMode === "true" && (
                              <Typography className="textPrint">
                                {" "}
                                {printData.modeOfTransport == ""
                                  ? "-"
                                  : printData.modeOfTransport}
                              </Typography>
                            )}
                            {invoiceSetting.showVehicleNo === "true" && (
                              <Typography className="textPrint">
                                {" "}
                                {printData.vehicleNo == ""
                                  ? "-"
                                  : printData.vehicleNo}
                              </Typography>
                            )}
                            {invoiceSetting.showPaymentTerms === "true" && (
                              <Typography className="textPrint">
                                {" "}
                                {printData.paymentTerms == ""
                                  ? "-"
                                  : printData.paymentTerms}
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
                <>
                  <TableContainer
                    style={{
                      minWidth: 650,
                      minHeight: printSetup.footerImgCheckbox === "true" ? 215 : 348,
                    }}
                  >
                    <Table size="small" style={{ borderCollapse: "collapse" }}>
                      <TableHead>
                        <TableRow>
                          <StyledTableCellPrint
                            align="left"
                            className="print_table_head"
                            style={{ borderLeft: "none" }}
                          >
                            SN.
                          </StyledTableCellPrint>
                          <StyledTableCellPrint
                            align="left"
                            className="print_table_head"
                            width="350"
                          >
                            Description of Goods
                          </StyledTableCellPrint>
                          <StyledTableCellPrint
                            align="left"
                            className="print_table_head"
                            width="74"
                          >
                            HSN Code
                          </StyledTableCellPrint>
                          <StyledTableCellPrint
                            align="right"
                            className="print_table_head"
                            width="55"
                          >
                            Quantity
                          </StyledTableCellPrint>
                          <StyledTableCellPrint
                            align="right"
                            className="print_table_head"
                            width="75"
                          >
                            Unit Price
                          </StyledTableCellPrint>
                          {invoiceSetting.showDiscountPer_details ===
                            "true" && (
                            // (row.discountPer !== 0 || row.discountPer !== '0' || row.discountPer !== null) &&
                            <StyledTableCellPrint
                              align="right"
                              className="print_table_head"
                              width="45"
                            >
                              Disc(%){" "}
                            </StyledTableCellPrint>
                          )}
                          {invoiceSetting.showNoOfPKG === "true" && (
                            <StyledTableCellPrint
                              align="right"
                              className="print_table_head"
                              width="45"
                            >
                              PKG{" "}
                            </StyledTableCellPrint>
                          )}
                          {invoiceSetting.showBatchNo === "true" && (
                            <StyledTableCellPrint
                              align="right"
                              className="print_table_head"
                              width="55"
                            >
                              Batch{" "}
                            </StyledTableCellPrint>
                          )}
                          <StyledTableCellPrint
                            align="right"
                            className="print_table_head"
                            width="110"
                            style={{ borderRight: "none" }}
                          >
                            Amount
                          </StyledTableCellPrint>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {JSON.parse(printData && printData.childRows).map(
                          (row, ind) => (
                            <StyledTableRow
                              style={{
                                "&:last-child td, &:last-child th": {
                                  border: "1px solid #616161",
                                },
                              }}
                            >
                              <StyledTableCellPrint
                                align="center"
                                className="print_table_body"
                                style={{ borderLeft: "none" }}
                              >
                                {ind + 1}.
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_body"
                              >
                                {invoiceSetting.itemThroughManualEntry ===
                                "true"
                                  ? row.itemDescription
                                  : row.itemName + " (" + row.itemCode + ")"}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_body"
                              >
                                {row.hsnCode}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="right"
                                className="print_table_body"
                              >
                                {row.quantity} {row.unit}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="right"
                                className="print_table_body"
                              >
                                {parseFloat(row.rate).toFixed(2)}
                              </StyledTableCellPrint>
                              {invoiceSetting.showDiscountPer_details ===
                                "true" && (
                                // (row.discountPer !== 0 || row.discountPer !== '0' || row.discountPer !== null) &&
                                <StyledTableCellPrint
                                  align="right"
                                  className="print_table_body"
                                >
                                  {row.discountPer}
                                </StyledTableCellPrint>
                              )}
                              {invoiceSetting.showNoOfPKG === "true" && (
                                <StyledTableCellPrint
                                  align="right"
                                  className="print_table_body"
                                >
                                  {row.noOfPkg}
                                </StyledTableCellPrint>
                              )}
                              {invoiceSetting.showBatchNo === "true" && (
                                <StyledTableCellPrint
                                  align="right"
                                  className="print_table_body"
                                >
                                  {row.batchNo}
                                </StyledTableCellPrint>
                              )}
                              <StyledTableCellPrint
                                align="right"
                                className="print_table_body"
                                style={{ borderRight: "none" }}
                              >
                                {parseFloat(row.amount).toFixed(2)}
                              </StyledTableCellPrint>
                            </StyledTableRow>
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
                <>
                  <Grid
                    container
                    style={{ height: "250px", borderTop: "1px solid #616161" }}
                  >
                    <Grid item xs={7.3} style={{}}>
                      <Box
                        style={{
                          textAlign: "left",
                          padding: "2px 4px 4px 8px",
                          height: "130px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          Terms & Conditions*
                        </Typography>
                        {terms &&
                          terms.map((row, index) => {
                            return (
                              <Grid container spacing={0} style={{ mt: 0 }}>
                                <Grid item xs={12}>
                                  <Box style={{ display: "flex" }}>
                                    {row.trueFalse == true && (
                                      <>
                                    
                                        <Typography
                                          style={{
                                            paddingBottom: "1px",
                                            fontSize: "11px",
                                            marginRight: "5px",
                                          }}
                                        >
                                          {" "}
                                          {index + 1} .{" "}
                                        </Typography>
                                        <Typography
                                          style={{
                                            paddingBottom: "1px",
                                            fontSize: "11px",
                                          }}
                                        >
                                          {" "}
                                          {row.termsAndConditions}{" "}
                                        </Typography>
                                      </>
                                    )}
                                  </Box>
                                </Grid>
                              </Grid>
                            );
                          })}
                      </Box>
                      <Box
                        style={{
                          borderTop: "1px solid #616161",
                          minHeight: "120px",
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                        }}
                      >
                        <Box>
                          <Typography
                            style={{
                              fontSize: "12px",
                              padding: "2px 2px 2px 8px",
                              textDecoration: "underline",
                            }}
                          >
                            Amount In Words
                          </Typography>
                          <Typography
                            style={{
                              fontSize: "13px",
                              fontWeight: "bold",
                              padding: "0px 2px 2px 8px",
                            }}
                          >
                            {convertToIndianWords(
                              Math.round(printData.total)
                            ).toLocaleUpperCase()}{" "}
                            ONLY.
                          </Typography>
                        </Box>

                        <Box style={{ borderTop: "1px solid #616161" }}>
                          <Typography
                            style={{
                              fontSize: "11px",
                              padding: "0px 2px 2px 8px",
                            }}
                          >
                            Whether Tax On Reverse Charge : Yes / No
                          </Typography>{" "}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={4.7}
                      style={{ borderLeft: "1px solid #616161" }}
                    >
                      <Table
                        aria-label="simple table"
                        style={{ borderCollapse: "collapse", height: "250px" }}
                      >
                        <TableBody>
                          <TableRow>
                            <StyledTableCellPrint
                              align="left"
                              className="print_table_bottom_body"
                              style={{ fontWeight: "bold", borderTop: "none" }}
                            >
                              Basic Amount{" "}
                            </StyledTableCellPrint>
                            <StyledTableCellPrint
                              align="left"
                              style={{
                                borderLeft: "1px solid #616161",
                                fontWeight: "bold",
                                borderTop: "none",
                                fontSize: "13px",
                              }}
                            >
                              {userInfo.currency}
                            </StyledTableCellPrint>
                            <StyledTableCellPrint
                              align="right"
                              width="120"
                              style={{
                                fontWeight: "bold",
                                borderTop: "none",
                                fontSize: "13px",
                              }}
                            >
                              {" "}
                              {parseFloat(printData.basicTotal).toFixed(2)}
                            </StyledTableCellPrint>
                          </TableRow>
                          {invoiceSetting.showDiscountPer_header === "true" &&
                            printData.discount_show == 1 && (
                              <>
                                <TableRow>
                                  <StyledTableCellPrint
                                    align="left"
                                    className="print_table_bottom_body"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Discount {printData.totalDiscountPer}%
                                  </StyledTableCellPrint>
                                  <StyledTableCellPrint
                                    align="left"
                                    className="print_table_bottom_body"
                                    style={{
                                      borderLeft: "1px solid #616161",
                                      fontWeight: "bold",
                                      borderTop: "none",
                                    }}
                                  >
                                    {userInfo.currency}
                                  </StyledTableCellPrint>
                                  <StyledTableCellPrint
                                    align="right"
                                    width="120"
                                    className="print_table_bottom_body"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {" "}
                                    {parseFloat(
                                      printData.totalDiscountAmt
                                    ).toFixed(2)}{" "}
                                  </StyledTableCellPrint>
                                </TableRow>
                              </>
                            )}

                          {invoiceSetting.showPackingForwarding === "true" &&
                            printData.packing_forwarding_show == 1 && (
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Packing & Forwarding{" "}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {" "}
                                  {parseFloat(
                                    printData.packing_forwarding
                                  ).toFixed(2)}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                            )}
                          {invoiceSetting.showFreightCharges === "true" &&
                            printData.freight_charges_show == 1 && (
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Freight Charges
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {" "}
                                  {parseFloat(
                                    printData.freight_charges
                                  ).toFixed(2)}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                            )}
                          {invoiceSetting.showTempoCharges === "true" &&
                            printData.tempo_charges_show == 1 && (
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Tempo Charges{" "}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {" "}
                                  {parseFloat(printData.tempo_charges).toFixed(
                                    2
                                  )}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                            )}
                          {invoiceSetting.showOtherCharges === "true" &&
                            printData.other_charges_show == 1 && (
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Other Charges{" "}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {" "}
                                  {parseFloat(printData.other_charges).toFixed(
                                    2
                                  )}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                            )}
                          <TableRow>
                            <StyledTableCellPrint
                              align="left"
                              className="print_table_bottom_body"
                              style={{ fontWeight: "bold" }}
                            >
                              Assessable Amount
                            </StyledTableCellPrint>
                            <StyledTableCellPrint
                              align="left"
                              style={{
                                borderLeft: "1px solid #616161",
                                fontWeight: "bold",
                                borderTop: "none",
                                fontSize: "13px",
                              }}
                            >
                              {userInfo.currency}
                            </StyledTableCellPrint>
                            <StyledTableCellPrint
                              align="right"
                              width="120"
                              style={{ fontWeight: "bold", fontSize: "13px" }}
                            >
                              {" "}
                              {parseFloat(printData.assessableAmt).toFixed(
                                2
                              )}{" "}
                            </StyledTableCellPrint>
                          </TableRow>
                          {printData.cgst !== 0 && (
                            <TableRow>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                CGST {printData.cgst}%
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{
                                  borderLeft: "1px solid #616161",
                                  fontWeight: "bold",
                                  borderTop: "none",
                                }}
                              >
                                {userInfo.currency}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="right"
                                width="120"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                {" "}
                                {parseFloat(printData.cgstTotal).toFixed(
                                  2
                                )}{" "}
                              </StyledTableCellPrint>
                            </TableRow>
                          )}
                          {printData.sgst !== 0 && (
                            <TableRow>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                SGST {printData.sgst}%
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{
                                  borderLeft: "1px solid #616161",
                                  fontWeight: "bold",
                                  borderTop: "none",
                                }}
                              >
                                {userInfo.currency}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="right"
                                width="120"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                {" "}
                                {parseFloat(printData.sgstTotal).toFixed(
                                  2
                                )}{" "}
                              </StyledTableCellPrint>
                            </TableRow>
                          )}
                          {printData.igstTotal !== 0 && (
                            <TableRow>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                IGST {printData.igst}%
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{
                                  borderLeft: "1px solid #616161",
                                  fontWeight: "bold",
                                  borderTop: "none",
                                }}
                              >
                                {userInfo.currency}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="right"
                                width="120"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                {" "}
                                {parseFloat(printData.igstTotal).toFixed(
                                  2
                                )}{" "}
                              </StyledTableCellPrint>
                            </TableRow>
                          )}
                          {invoiceSetting.showRoundOff === "true" ? (
                            <>
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Total Amount
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                    fontSize: "13px",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>

                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "13px",
                                  }}
                                >
                                  {parseFloat(printData.total).toFixed(2)}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Round Off
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>

                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {parseFloat(printData.round_off).toFixed(2)}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                              <TableRow>
                                <StyledTableCellPrint
                                  align="left"
                                  className="print_table_bottom_body"
                                  style={{ fontWeight: "bold" }}
                                >
                                  Invoice Amount{" "}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="left"
                                  style={{
                                    borderLeft: "1px solid #616161",
                                    fontWeight: "bold",
                                    borderTop: "none",
                                    fontSize: "13px",
                                  }}
                                >
                                  {userInfo.currency}
                                </StyledTableCellPrint>
                                <StyledTableCellPrint
                                  align="right"
                                  width="120"
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "13px",
                                  }}
                                >
                                  {parseFloat(
                                    Math.round(printData.total)
                                  ).toFixed(2)}{" "}
                                </StyledTableCellPrint>
                              </TableRow>
                            </>
                          ) : (
                            <TableRow>
                              <StyledTableCellPrint
                                align="left"
                                className="print_table_bottom_body"
                                style={{ fontWeight: "bold" }}
                              >
                                Invoice Amount
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="left"
                                style={{
                                  borderLeft: "1px solid #616161",
                                  fontWeight: "bold",
                                  borderTop: "none",
                                  fontSize: "13px",
                                }}
                              >
                                {userInfo.currency}
                              </StyledTableCellPrint>
                              <StyledTableCellPrint
                                align="right"
                                width="120"
                                style={{ fontWeight: "bold", fontSize: "13px" }}
                              >
                                {parseFloat(printData.total).toFixed(2)}{" "}
                              </StyledTableCellPrint>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>

                  <Grid container style={{ height: "140px" }}>
                    <Grid
                      item
                      xs={7.3}
                      style={{ borderTop: "1px solid #616161" }}
                    >
                      <Box style={{ padding: "2px 2px 2px 8px" }}>
                        <Typography
                          style={{ fontSize: "10px", lineHeight: "10px" }}
                        >
                          I/we hereby certify that my/our Registration
                          Certificate under the GST Act 2017 is in force on the
                          date on which the sale of goods specified in this GST
                          invoice is made by me/ us & that the transaction of
                          sale is covered by this GST invoice has been affected
                          me/us and it shall be accounted for in the trunover of
                          sales while filling of return & the due GST,if any,
                          payable on the sale has been paid or shall be paid.
                        </Typography>
                      </Box>
                      {invoiceSetting.showBankDetails === "true" && (
                        <Box
                          style={{
                            padding: "0px 2px 2px 8px",
                            borderTop: "1px solid #616161",
                          }}
                        >
                          <Grid container>
                            <Grid
                              item
                              xs={7}
                              style={{ borderRight: "1px solid #616161" }}
                            >
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  lineHeight: "1.2",
                                  textDecoration: "underline",
                                  paddingTop: "3px",
                                }}
                              >
                                OUR BANK DETAILS
                              </Typography>
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  lineHeight: "1.2",
                                }}
                              >
                                A/C NAME- {printData.bankAccountName}
                              </Typography>
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  lineHeight: "1.2",
                                }}
                              >
                                A/C NO- {printData.bankAccountNumber}
                              </Typography>
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  lineHeight: "1.2",
                                }}
                              >
                                BANK NAME- {printData.bankName}
                              </Typography>
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  lineHeight: "1.2",
                                }}
                              >
                                BRANCH- {printData.branchName}
                              </Typography>
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  lineHeight: "1.2",
                                }}
                              >
                                IFSC CODE- {printData.ifscCode}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} style={{ marginTop: "65px" }}>
                              <Typography
                                style={{
                                  color: "#000000",
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                Receiver's Signature & Seal
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={4.7}
                      style={{
                        borderLeft: "1px solid #616161",
                        maxHeight: "140px",
                      }}
                    >
                      <Typography
                        style={{
                          textAlign: "right",
                          fontSize: "12px",
                          marginRight: "10px",
                        }}
                      >
                        For{" "}
                        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                          {" "}
                          {userInfo.company}{" "}
                        </span>
                      </Typography>
                     
                      <Box
                        style={{
                          minHeight: "104px",
                          maxHeight: "104px",
                          height: "104px",
                          justifyContent: "center",
                          display: "flex",
                          align: "center",
                        }}
                      >
                        {printSetup.signatureImgCheckbox === "true" && (
                          <img
                            src={printSetup.signatureImage}
                            style={{
                              minHeight: "104px",
                              maxHeight: "104px",
                              height: "104px",
                              width: "150px",
                              minWidth: "150px",
                              maxWidth: "150px",
                            }}
                          />
                        )}
                      </Box>

                      <Typography
                        style={{
                          color: "#000000",
                          textAlign: "right",
                          fontSize: "12px",
                          marginRight: "10px",
                        }}
                      >
                        Authorized Signatory
                      </Typography>
                      {/* </Box> */}
                    </Grid>
                  </Grid>
                </>
              </Box>
              <Box
                style={{ marginLeft: "30px", height: "20px", display: "flex" }}
              >
                <Grid container>
                  <Grid item xs={4}>
                    {printSetup.invoiceTag1 && (
                      <Typography
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                      >
                        {printSetup.invoiceTag1}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    {printSetup.invoiceTag2 && (
                      <Typography
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                      >
                        {printSetup.invoiceTag2}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    {printSetup.invoiceTag3 && (
                      <Typography
                        style={{
                          fontSize: "10px",
                          fontWeight: "bold",
                          float: "right",
                          marginRight: "30px",
                        }}
                      >
                        {printSetup.invoiceTag3}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>

              {printSetup.footerImgCheckbox === "true" && (
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    style={{ paddingRight: "20px", paddingLeft: "20px" }}
                  >
                    {printSetup.footerImage && (
                      <img
                        src={printSetup.footerImage}
                        alt="Footer Image"
                        style={{ width: "100%", height: "65px" }}
                      />
                    )}
                  </Grid>
                </Grid>
              )}
            </Paper>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default SalesInvoiceMailFormat;
